import angular from 'angular';

import { ListView } from '@/react/portainer/users/ListView/ListView';
import { ItemView as UserDetailView } from '@/react/portainer/users/ItemView/ItemView';
import { r2a } from '@/react-tools/react2angular';
import { withCurrentUser } from '@/react-tools/withCurrentUser';
import { withReactQuery } from '@/react-tools/withReactQuery';
import { withUIRouter } from '@/react-tools/withUIRouter';

export const usersModule = angular
  .module('portainer.app.react.views.users', [])

  .component(
    'usersListView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(ListView))), [])
  )
  .component(
    'userDetailView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(UserDetailView))), [])
  ).name;
